    App.filter('addressRecognition', function addressRecognitionFilter() {
        this.$inject = [];

        return function (value) {
            var mapped = [];
            if (value && Object.prototype.toString.call(value) === '[object Array]') {
                /**
                 * Maps cities
                 */
                var _cityHelper = [],
                    _valueLength = value.length;
                for (var i = 0; i < _valueLength; i++) {
                    if (_cityHelper.indexOf(value[i].city) === -1) {
                        _cityHelper.push(value[i].city);
                    }
                }
                /**
                 * Maps streets and posts;
                 * @type {{city: *, streets: Array, posts: Array}[]}
                 */
                mapped = _cityHelper.map(function (city) {
                    var streets = [];
                    for (var i = 0; i < _valueLength; i++) {
                        if (city === value[i].city) {
                            if (value[i].street && streets.indexOf(value[i].street) === -1) streets.push(value[i].street);
                        }
                    }
                    return {city: city, streets: streets};
                });
            }
            return mapped;
        }
    });


